// getGiftPreviewMeta.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getGiftData from '../selector/getGiftData.js';
import { GiftUiType } from '../resource/giftConstants.js';

/**
 * Select the minimum gift metadata needed to populate the preview panel and
 * selected-state border. Result is memoized per gift id so it can be safely
 * passed as a prop without breaking shallow comparison.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} id - gift id.
 * @returns {{id: string, image: string, pagImage: string, isPagGift: boolean, isAnimationGift: boolean}|null}
 * @example
 * getGiftPreviewMeta(state, 'rose');
 * // => { id: 'rose', image: '.../rose.png', pagImage: '.../rose.pag', isPagGift: true, isAnimationGift: false }
 */
const getGiftPreviewMeta = createCachedSelector(
  (state, id) => id,
  (state, id) => getGiftData(state, id, 'image'),
  (state, id) => getGiftData(state, id, 'pagImage'),
  (state, id) => getGiftData(state, id, 'uiType'),
  (id, image, pagImage, uiType) => {
    if (!id) return null;
    return {
      id,
      image: image || '',
      pagImage: pagImage || '',
      isAnimationGift: uiType === GiftUiType.APNG,
      isPagGift: uiType === GiftUiType.PAG,
    };
  }
)((state, id) => `${id}`);

export default getGiftPreviewMeta;
